const initialState = {
    loadingPayload: false
}

const LoadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOADING_STATUS":
            return {
                ...state,
                loadingPayload: action.payload
            }
        default:
            return state
    }
}
export default LoadingReducer
